import * as React from 'react';
import styled from '@emotion/styled';
import { Box, Text } from '@eds-web/react';
import { CircularProgress } from '@mui/material';

export const IframeContainer = styled.div`
    width: 1200px;
    margin: 0 auto;
    min-height: 800px;
    position: relative;
`;

export const Iframe = styled.iframe`
    border: 0;
    width: 100%;
    min-height: 800px;
    text-align: left;
    direction: ltr;
    position: relative;
`;

const LoadingContainer = styled(Box)`
    display: flex;
    justify-content: center;
    width: 100%;
    position: absolute;
`;

export const Loading = () => (
    <LoadingContainer textAlign="center" marginTop="10vh">
        <CircularProgress />
    </LoadingContainer>
);

export const InterviewIframe: React.FC<{ url: string; eventName?: string }> = ({
    url,
    eventName
}) => (
    <>
        {eventName && (
            <Text
                style={{ padding: '24px 0', textAlign: 'left', width: '1200px', margin: '0 auto' }}
                variant={'headingLG'}
            >
                Forms for {eventName}
            </Text>
        )}
        <IframeContainer>
            <Loading />
            <Iframe
                sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-modals"
                title="Tax Identity Interview"
                src={url}
            />
        </IframeContainer>
    </>
);
